import { render, staticRenderFns } from "./STree.vue?vue&type=template&id=4bf7cdba";
import script from "./STree.vue?vue&type=script&lang=js";
export * from "./STree.vue?vue&type=script&lang=js";
import style0 from "./STree.vue?vue&type=style&index=0&id=4bf7cdba&prod&lang=less";

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, null, null);
export default component.exports;